import styled from "styled-components";
import { Colors } from "../theme";
import { useState, useEffect } from "react";
import { Menu as MenuIcon, X } from "lucide-react";
import LanguageButtons from "../ui/LanguageButtons";

// Pasek górny z przyciskiem
const MobileMenuBar = styled.div`
  background-color: ${Colors.red};
  margin: 0;
  padding: 10px 20px;
  z-index: 1000;
  color: ${Colors.white};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (min-width: 992px) {
    display: none;
  }
`;

// Kontener na rozwijane menu
const MobileMenuContent = styled.div`
  position: fixed;
  top: 60px;
  left: 0;
  width: 100%;
  background-color: ${Colors.red};
  color: ${Colors.white};
  padding: 20px;
  transform-origin: top;
  transform: scaleY(${(props) => (props.active ? 1 : 0)});
  transition: transform 0.25s ease-in-out;
  z-index: 999;

  /* kluczowe: przewijanie wewnątrz menu */
  max-height: calc(100vh - 60px);
  overflow-y: auto;

  @media (min-width: 992px) {
    display: none;
  }

  a {
    color: ${Colors.white};
    text-decoration: none;
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(255,255,255,0.3);
    border-radius: 3px;
  }
`;

export default function MobileMenu({ children }) {
  const [active, setActive] = useState(false);

  // Blokuj przewijanie tła, gdy menu otwarte
  useEffect(() => {
    document.body.style.overflow = active ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [active]);

  // zamykanie menu po kliknięciu w link
  useEffect(() => {
    if (!active) return;

    const handleClick = (e) => {
      const link = e.target.closest("a");
      if (link) setActive(false);
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [active]);

  return (
    <>
      <MobileMenuBar>
        <div style={{ fontWeight: "bold", fontSize: "1.2rem" }}>LOGO</div>
        <button
          onClick={() => setActive(!active)}
          style={{
            background: "transparent",
            border: "none",
            color: Colors.white,
          }}
        >
          {active ? <X size={30} /> : <MenuIcon size={30} />}
        </button>
      </MobileMenuBar>

      <MobileMenuContent active={active}>
        <LanguageButtons className="mb-3" />
        {children}
      </MobileMenuContent>
    </>
  );
}